import { ErrorHandler, Injectable } from '@angular/core';
import { ErrorReporter } from '@mode/shared/contract-common';

@Injectable()
export class ReportSandboxErrorHandler extends ErrorHandler {
  override handleError(error: any): void {
    this.errorReporter.notify({ error, context: 'ReportSandbox', unhandled: true, severity: 'error' });
    super.handleError(error);
  }

  constructor(private errorReporter: ErrorReporter) {
    super();
  }
}
